import { api } from ":mods";
import { CONST, model } from "..";

export async function listGet(stage_id: string | number) {
  return api.getAuth(CONST.ENDPOINTS.non_admin.list_showcase(stage_id)).then((res) => res.data as model.ShowcasesList);
}
